"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vue = _interopRequireDefault(require("vue"));
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _vueFontawesome = require("@fortawesome/vue-fontawesome");
_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faCheck, _freeSolidSvgIcons.faEye, _freeSolidSvgIcons.faPeopleCarry, _freeSolidSvgIcons.faBuilding, _freeSolidSvgIcons.faUser, _freeSolidSvgIcons.faMoneyBill);
_vue.default.component("font-awesome-icon", _vueFontawesome.FontAwesomeIcon);